<template>
  <v-container>
    <v-row>
      <v-col>
        <go-back-btn :routeToGo="routeToGo" />
        <PageHeader :title="title" class="mb-3" />
        <!-- Data table -->
        <v-card class="mb-4 pb-2">
          <v-form
            v-model="isFormValid"
            ref="form-filter-viajes"
            form="form-filter-viajes"
            id="form-filter-viajes"
            @submit.prevent="loadViajes()"
          >
            <v-row class="pb-2">
              <v-col cols="4" class="py-4 pl-6">
                <v-autocomplete
                  v-model="clienteSelected"
                  :items="clientes"
                  clearable
                  item-text="value"
                  item-value="id"
                  outlined
                  return-object
                  dense
                  hide-details="auto"
                  label="Cliente"
                  :filter="removeAccentsFilter"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4" class="py-4">
                <v-menu
                  ref="menu-fecha-salida"
                  v-model="menuFechaViajeDesde"
                  :close-on-content-click="false"
                  :open-on-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechaViajeDesdeSelected"
                      label="Fecha desde"
                      :append-icon="calendarIcon"
                      v-bind="attrs"
                      outlined
                      hide-details="auto"
                      clearable
                      dense
                      hint="Formato DD/MM/AAAA"
                      v-mask="'##/##/####'"
                      @blur="
                        fechaViajeDesde = parseDateToIso(
                          fechaViajeDesdeSelected
                        )
                      "
                      v-on="on"
                      :rules="
                        fechaViajeDesdeSelected || fechaViajeHastaSelected
                          ? rules.required.concat(
                              rules.validDate,
                              rules.validDateRange(
                                fechaViajeDesde,
                                fechaViajeHasta
                              )
                            )
                          : []
                      "
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fechaViajeDesde"
                    no-title
                    @change="
                      fechaViajeDesdeSelected = formatDate(fechaViajeDesde)
                    "
                    @input="menuFechaViajeDesde = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4" class="py-4 pr-6">
                <v-menu
                  ref="menu-fecha-salida"
                  v-model="menuFechaViajeHasta"
                  :close-on-content-click="false"
                  :open-on-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechaViajeHastaSelected"
                      label="Fecha hasta"
                      :append-icon="calendarIcon"
                      v-bind="attrs"
                      outlined
                      hide-details="auto"
                      clearable
                      dense
                      hint="Formato DD/MM/AAAA"
                      v-mask="'##/##/####'"
                      @blur="
                        fechaViajeHasta = parseDateToIso(
                          fechaViajeHastaSelected
                        )
                      "
                      v-on="on"
                      :rules="
                        fechaViajeDesdeSelected || fechaViajeHastaSelected
                          ? rules.required.concat(
                              rules.validDate,
                              rules.validDateRange(
                                fechaViajeDesde,
                                fechaViajeHasta
                              )
                            )
                          : []
                      "
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fechaViajeHasta"
                    no-title
                    @change="
                      fechaViajeHastaSelected = formatDate(fechaViajeHasta)
                    "
                    @input="menuFechaViajeHasta = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="pt-0 pb-5 pl-6">
                <v-autocomplete
                  v-model="motivoViajeSelected"
                  :items="motivosViaje"
                  clearable
                  item-text="value"
                  item-value="id"
                  outlined
                  return-object
                  dense
                  hide-details="auto"
                  label="Motivos de viaje"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4" class="pt-0 pb-5">
                <v-autocomplete
                  v-model="medioTransporteSelected"
                  :items="mediosTransporte"
                  clearable
                  item-text="value"
                  item-value="id"
                  outlined
                  return-object
                  dense
                  hide-details="auto"
                  label="Medios de transporte"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4" align-self="end" class="text-right pr-7 pt-0">
                <v-btn
                  color="primary"
                  :disabled="!isFormValid"
                  small
                  class="to-right mt-1"
                  :dark="isFormValid"
                  type="submit"
                  form="form-filter-viajes"
                >
                  Aplicar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
        <v-card>
          <v-data-table
            class="elevation-2"
            :headers="headers"
            :items="itemsViajes"
            :loading="loading"
            no-data-text="No hay datos disponibles para mostrar"
            :search="searchConsulta"
            :custom-filter="customFilterIgnoreAccents"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-row>
                  <v-col cols="10" align-self="center" class="pt-5">
                    <v-text-field
                      v-model="searchConsulta"
                      clearable
                      label="Buscar"
                      single-line
                      :append-icon="iconoSearch"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" align="end" class="pt-5 text-right">
                    <v-btn
                      v-if="canCreateNewViajes"
                      color="primary"
                      @click="openModal(undefined, false)"
                      class="to-right"
                    >
                      Nuevo
                    </v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    size="20"
                    v-on="on"
                    @click="openModal(item, true)"
                  >
                    {{ seeIcon }}
                  </v-icon>
                </template>
                <span>Ver viaje</span>
              </v-tooltip>
              <v-tooltip v-if="canEditViajes" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    size="20"
                    v-on="on"
                    @click="openModal(item, false)"
                  >
                    {{ editIcon }}
                  </v-icon>
                </template>
                <span>Editar viaje</span>
              </v-tooltip>
              <v-tooltip v-if="canDeleteViajes" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    size="20"
                    v-on="on"
                    @click="openDeleteViaje(item.viajeId)"
                  >
                    {{ deleteIcon }}
                  </v-icon>
                </template>
                <span>Eliminar viaje</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-if="openModalViajes"
      v-model="openModalViajes"
      max-width="75%"
      @keydown.esc="closeAndReload"
      persistent
    >
      <EditViajes
        :viajesObject="viajesObject"
        :verViaje="verViaje"
        @closeAndReload="closeAndReload"
      ></EditViajes>
    </v-dialog>
    <DeleteDialog
      max-width="25%"
      :isLoading="loadingDelete"
      :titleProp="titleDelete"
      :openDelete.sync="showDeleteModal"
      @onDeleteItem="confirmDelete()"
    />
  </v-container>
</template>

<script>
import PageHeader from "@/components/ui/PageHeader.vue";
import { mapActions } from "vuex";
import { mask } from "vue-the-mask";
import enums from "@/utils/enums/index.js";
import enumsAdmin from "@/utils/enums/modules/index.js";
import GoBackBtn from "@/components/shared/GoBackBtn";
import EditViajes from "@/components/EditViajes.vue";
import rules from "@/utils/helpers/rules";
import DeleteDialog from "@/components/shared/DeleteDialog";

export default {
  directives: { mask },
  components: { PageHeader, GoBackBtn, EditViajes, DeleteDialog },
  name: "Viajes",
  data() {
    return {
      rules: rules,
      titleDelete: "¿Eliminar viaje?",
      showDeleteModal: false,
      loading: false,
      routeToGo: "/",
      isFormValid: false,
      editIcon: enums.icons.EDIT,
      deleteIcon: enums.icons.DELETE,
      searchConsulta: null,
      iconoSearch: enums.icons.SEARCH_ICON,
      seeIcon: enums.icons.SEE,
      openModalViajes: false,
      itemsViajes: [],
      motivoViajeSelected: null,
      motivosViaje: [],
      medioTransporteSelected: null,
      mediosTransporte: [],
      clienteSelected: null,
      clientes: [],
      fechaViajeDesde: null,
      fechaViajeDesdeSelected: null,
      menuFechaViajeDesde: null,
      fechaViajeHasta: null,
      fechaViajeHastaSelected: null,
      menuFechaViajeHasta: null,
      calendarIcon: enums.icons.CALENDAR,
      title: "Viajes",
      idToDelete: null,
      registrosViajes: {},
      canCreateNewViajes: true,
      canEditViajes: true,
      canDeleteViajes: true,
      loadingDelete: false,
      verViaje: false,
      headers: [
        {
          text: "Fecha y hora de salida",
          sortable: false,
          value: "fechaDesdeToShow",
        },
        {
          text: "Fecha y hora de llegada",
          sortable: false,
          value: "fechaHastaToShow",
        },
        { text: "Cliente", sortable: false, value: "clienteNom" },
        { text: "Motivo", sortable: false, value: "motivosNom" },
        {
          text: "Medio transporte",
          sortable: false,
          value: "mediosTransporteNom",
        },
        { text: "Acciones", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  async created() {
    this.setSelect();
    this.setPermisos();
  },
  methods: {
    ...mapActions({
      getViajesByFilters: "clientesData/getViajesByFilters",
      deleteViajes: "clientesData/deleteViajes",
      getMotivosViaje: "clientesData/motivosViajeTaxonomy",
      getClientes: "clientesData/clientesTaxonomy",
      getMediosTransporte: "clientesData/mediosTransporteTaxonomy",
      setAlert: "user/setAlert",
    }),
    async setSelect() {
      const motivosViaje = await this.getMotivosViaje();
      this.motivosViaje = motivosViaje;
      const mediosTransporte = await this.getMediosTransporte();
      this.mediosTransporte = mediosTransporte;
      const clientes = await this.getClientes();
      this.clientes = clientes;
    },
    setPermisos() {
      this.allowedActions = JSON.parse(localStorage.getItem("allowedActions"));
      this.allowedActions?.forEach((x) => {
        switch (x.optionCode) {
          case enumsAdmin.adminSistema.permissions.NUEVO_Viajes:
            this.canCreateNewViajes = true;
            break;
          case enumsAdmin.adminSistema.permissions.EDIT_Viajes:
            this.canEditViajes = true;
            break;
          case enumsAdmin.adminSistema.permissions.DELETE_Viajes:
            this.canDeleteViajes = true;
            break;
          default:
            break;
        }
      });
    },
    openModal(item, ver) {
      this.openModalViajes = true;
      this.viajesObject = item;
      this.verViaje = ver;
    },
    closeAndReload() {
      this.openModalViajes = false;
      this.loadViajes();
    },
    async loadViajes() {
      this.loading = true;
      const params = {
        clienteId: this.clienteSelected?.id,
        fechaViajeDesde: this.fechaViajeDesde,
        fechaViajeHasta: this.fechaViajeHasta,
        mvId: this.motivoViajeSelected?.id,
        mtId: this.medioTransporteSelected?.id,
      };
      const response = await this.getViajesByFilters(params);
      this.itemsViajes = response;
      this.loading = false;
    },
    openDeleteViaje(id) {
      this.showDeleteModal = true;
      this.idToDelete = id;
    },
    async confirmDelete() {
      this.loadingDelete = true;
      const response = await this.deleteViajes(this.idToDelete);
      if (response.status === 200) {
        this.showDeleteModal = false;
        this.setAlert({ type: "success", message: "Eliminado con éxito." });
        this.loadViajes();
      }
      this.loadingDelete = false;
    },
    removeAccentsFilter(item, queryText, itemText) {
      const normalize = (str) =>
        str
          .toString()
          .normalize("NFD") // descompone caracteres con acento
          .replace(/[\u0300-\u036f]/g, "") // elimina los acentos
          .toLowerCase();

      return normalize(itemText).includes(normalize(queryText));
    },
    removeAccents(text) {
      if (!text) return "";
      return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    customFilterIgnoreAccents(value, search) {
      return this.removeAccents(value).includes(this.removeAccents(search));
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateToIso(date) {
      if (!date) return null;
      if (date.length === 10) {
        const [day, month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
  },
};
</script>

  